import { apiService } from "@/common/api.service.js";

export default {
  // EnergyEye recent queries
  userEnergyEyeRecentQueries(payload) {
    const endpoint = `/energy-eye/energy-eye-recent-query/?user=${payload.user}`;
    return apiService(endpoint);
  },

  energyEyeRecentQueryCreate(payload) {
    const endpoint = `/energy-eye/energy-eye-recent-query-create/`;
    return apiService(endpoint, "POST", payload);
  },

  // EnergyEye dashboards
  energyEyeDashboards() {
    const endpoint = `/energy-eye/nested-energyeye-dashboards/`;
    return apiService(endpoint);
  },

  // EnergyEye data (select menus)
  energyEyeData(site_code) {
    const endpoint = `/energy-eye/energy-eye-data/${site_code}/`;
    return apiService(endpoint);
  },

  // Execute EnergyEye query
  executeEnergyEyeQuery(payload) {
    const endpoint = `/energy-eye/execute-query/`;
    return apiService(endpoint, "POST", payload);
  },
};
